import { render } from "./Declaracoes.vue?vue&type=template&id=85a25bb4&scoped=true"
import script from "./Declaracoes.vue?vue&type=script&lang=js"
export * from "./Declaracoes.vue?vue&type=script&lang=js"

import "./Declaracoes.vue?vue&type=style&index=0&id=85a25bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a25bb4"]])

export default __exports__